import "core-js/modules/es.reflect.construct.js";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Landmark from 'components/Landmark';
import Text from 'components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
function injectHeightProp(element, height) {
  if (!height) return element;
  return /*#__PURE__*/React.cloneElement(element, {
    height: height
  });
}
var EmptyStateController = /*#__PURE__*/function (_Component) {
  function EmptyStateController(props) {
    var _this;
    _classCallCheck(this, EmptyStateController);
    _this = _callSuper(this, EmptyStateController, [props]);
    _this.state = {
      hasCaughtError: false
    };
    return _this;
  }
  _inherits(EmptyStateController, _Component);
  return _createClass(EmptyStateController, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$isLoading = _this$props.isLoading,
        isLoading = _this$props$isLoading === void 0 ? false : _this$props$isLoading,
        _this$props$isEmpty = _this$props.isEmpty,
        isEmpty = _this$props$isEmpty === void 0 ? false : _this$props$isEmpty,
        _this$props$isError = _this$props.isError,
        isError = _this$props$isError === void 0 ? false : _this$props$isError,
        data = _this$props.data,
        height = _this$props.height,
        _this$props$loadingCo = _this$props.loadingContent,
        loadingContent = _this$props$loadingCo === void 0 ? /*#__PURE__*/_jsx(Landmark, {
          icon: "spinner"
        }) : _this$props$loadingCo,
        _this$props$emptyCont = _this$props.emptyContent,
        emptyContent = _this$props$emptyCont === void 0 ? /*#__PURE__*/_jsx(Landmark, {
          icon: "ellipsis",
          children: /*#__PURE__*/_jsx(Text, {
            bold: true,
            as: "p",
            children: this.props.t('error_no_data_to_display')
          })
        }) : _this$props$emptyCont,
        _this$props$errorCont = _this$props.errorContent,
        errorContent = _this$props$errorCont === void 0 ? /*#__PURE__*/_jsx(Landmark, {
          icon: "logout",
          children: /*#__PURE__*/_jsx(Text, {
            bold: true,
            as: "p",
            children: this.props.t('error_could_not_load_data')
          })
        }) : _this$props$errorCont,
        children = _this$props.children;
      var hasCaughtError = this.state.hasCaughtError;
      if (isLoading || data === null) {
        return injectHeightProp(loadingContent, height);
      } else if (hasCaughtError || isError || _typeof(data) === 'object' && !Array.isArray(data) && data.error) {
        return injectHeightProp(errorContent, height);
      } else {
        if (isEmpty || Array.isArray(data) && data.length === 0) {
          return injectHeightProp(emptyContent, height);
        } else {
          return children;
        }
      }
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasCaughtError: true
      };
    }
  }]);
}(Component);
export default withTranslation()(EmptyStateController);